import src from "IMAGE";
export default { src, width: 300, height: 65, blurWidth: 8, blurHeight: 2, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAACCAYAAABllJ3tAAAATUlEQVR42gFCAL3/AHV2lmiAhJFiio6dXY+PtGeSla9jnKCyW5+iunOVnKNfAHJ+hSl8i3sqhZGFLJ2mmlyNlZNXh5WALIubdy2JmHQpQ90f9VwqXZwAAAAASUVORK5CYII="};
